<template src="./Edit.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },

    created() {
        this.$store.dispatch("lookups/getDepartments");
        this.$store.dispatch("lookups/getSpecialties");
        this.$store.dispatch("lookups/getLookups");

        this.$store
            .dispatch("doctors/getForEdit", this.itemId)
            .then((res) => {
                this.vm = res;
            }).catch(() => { });
    },
    computed: {
        departments() {
            return this.$store.state.lookups.departments;
        },
        specialties() {
            return this.$store.state.lookups.specialties;
        },
        paymentTypes() {
      return [
        ...this.$store.getters["lookups/getLookupByType"](
          this.$lookupTypes.paymentTypes
        )];
    },
     gender() {
      return [
        { value: 2, label: "انثي" },
        { value: 1, label: "ذكر" },
      ]
    },

    },
    data() {
        return {
            vm: {
                
        operatingExpenseRatio:null,
        birthDate:null,
        gender:null,
                fullName: null,
                qualificationId: null,
                email: null,
                phoneNo: null,
                specialtyId: null,
            },

        };
    },
    methods: {
        ChangePaymentType(){
            this.vm.fixedSalary = null;
            this.vm.commissionRate = null;
        },
        confirm() {
            this.$store
                .dispatch("doctors/edit", { id: this.itemId, payload: this.vm })
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },
        allowedDates(val) {
            const today = new Date();
            today.setFullYear(today.getFullYear() - 15);
            const date = new Date(val);
            return date < today;
        },
        back() {

            this.$emit("back");
        },
    },
};
</script>